import * as Yup from "yup";

export const getValidationSchema = (tab) => {
  switch (tab) {
    case 1:
      return Yup.object({
        unit_type: Yup.string().required("Please Select Unit Type"),
        block: Yup.string().required("Please Select Block"),
        floor: Yup.string().required("Please Enter Floor"),
        nr: Yup.string().required("Please Enter Number"),
        initial_price: Yup.string().required("Please Enter Initial Price"),
      });
    case 2:
      return Yup.object({
        num_rooms: Yup.string().required("Please Enter Number of Rooms"),
        net_sqm: Yup.string().required("Please Enter Net Square Meters"),
        gross_sqm: Yup.string().required("Please Enter Gross Square Meters"),
        apt_net_sqm: Yup.string().required("Please Enter Apartment Square Meters"),
        terrace_net_sqm: Yup.string().required("Please Enter Terrace Square Meters"),
      });
    default:
      return Yup.object({});
  }
};
